import * as fields from './fields';
import * as resources from './resources';

// Helper
import { ChartType, allChartTypesWithAreaSpline } from './common/chart-types';
import dateStringToUnix from '../helpers/date-string-to-unix';
import { getDefaultDateRange, isDateDisabled, DEFAULT_PROCESSING_LAG_DAYS } from '../helpers/google-trends-date-helper';

export const config = {
    pageTitle: 'Google Search Trends',
    reportDescription:
        'Explore search trends from Google Trends by keyword Market and Category. This report updates on the 1st and 14th of each month, and runs two weeks in arrears.',
    dateDimension: fields.SEO_TREND_DATE_DATE,
    filters: {
        status: {
            isEnableDatePicker: true,
            isEnableProductSelect: false,
            isEnableMetrics: true,
        },
        datePicker: {
            customStartDate: () => getDefaultDateRange(DEFAULT_PROCESSING_LAG_DAYS).startDate,
            customEndDate: () => getDefaultDateRange(DEFAULT_PROCESSING_LAG_DAYS).endDate,
            disabledDays: date => isDateDisabled(date, DEFAULT_PROCESSING_LAG_DAYS),
        },
    },
    resources: [resources.REPORT_SEOPT_GOOGLE_TRENDS, resources.REPORT_SEOPT_GOOGLE_TRENDS_URL],
    ignoreProducts: true,
    chart: {
        chartType: ChartType.AreaSpline,
        allowedChartTypes: allChartTypesWithAreaSpline,
        chartId: 'report-seogd-google-trends-traffic',
        allYMetrics: [
            fields.GOOGLE_TRENDS_HITS,
            fields.GOOGLE_TRENDS_CHANGE_OVER_TIME,
            fields.GOOGLE_TRENDS_CHANGE_OVER_TIME_PCT,
        ],
        initialYMetrics: [fields.GOOGLE_TRENDS_HITS],
        dataFormatter: function (_, datas, dimension, metric) {
            return datas.map(data => {
                return [dateStringToUnix(data[dimension.rawName].raw_value), data[metric].raw_value];
            });
        },
    },
    table: {
        hideTotals: true,
        tabListItems: [
            {
                tabName: 'Search Trends',
                displayName: 'Search Trends',
                isSelected: true,
                metrics: [
                    fields.GOOGLE_TRENDS_HITS,
                    fields.GOOGLE_TRENDS_CHANGE_OVER_TIME,
                    fields.GOOGLE_TRENDS_CHANGE_OVER_TIME_PCT,
                ],
            },
            {
                tabName: 'Search Trends YoY',
                displayName: 'Search Trends YoY',
                isSelected: true,
                metrics: [
                    fields.GOOGLE_TRENDS_HITS_SD_YOY,
                    fields.GOOGLE_TRENDS_HITS_ED_YOY,
                    fields.GOOGLE_TRENDS_CHANGE_OVER_TIME_LAST_YEAR,
                ],
            },
        ],
        fieldDataOverrides: {},
        fieldParentOverrides: {},
        fieldChildren: {
            [fields.MARKET_KEYWORD_COUNTRY.id]: {
                default: [
                    {
                        resource: resources.REPORT_SEOPT_GOOGLE_TRENDS,
                        field: fields.CORE_PARENT_CAT,
                    },
                ],
            },
            [fields.CORE_PRODUCT.id]: {
                default: [
                    {
                        resource: resources.REPORT_SEOPT_GOOGLE_TRENDS,
                        field: fields.CORE_PARENT_CAT,
                    },
                ],
            },
            [fields.CORE_PARENT_CAT.id]: {
                default: [
                    {
                        resource: resources.REPORT_SEOPT_GOOGLE_TRENDS,
                        field: fields.CORE_CHILD_CAT,
                    },
                ],
            },
            [fields.CORE_CHILD_CAT.id]: {
                default: [
                    {
                        resource: resources.REPORT_SEOPT_GOOGLE_TRENDS,
                        field: fields.CORE_SUB_CAT,
                    },
                ],
            },
            [fields.CORE_SUB_CAT.id]: {
                default: [
                    {
                        resource: resources.REPORT_SEOPT_GOOGLE_TRENDS,
                        field: fields.MARKET_KEYWORD_KEYWORD,
                    },
                ],
            },
            [fields.KEYWORD_MODIFIER.id]: {
                default: [
                    {
                        resource: resources.REPORT_SEOPT_KEYWORDS_LANDING,
                        field: fields.LOCALE,
                    },
                ],
            },
            [fields.LOCALE.id]: {
                default: [
                    {
                        resource: resources.REPORT_SEOPT_KEYWORDS_LANDING,
                        field: fields.CORE_PARENT_CAT,
                    },
                ],
            },
        },
    },
    pagination: {
        currentPage: 1,
        currentRange: [1, 25],
        minPage: 1,
        maxPage: 100,
        totalResults: 12345,
        maxButtons: 10,
        rowDefault: 25,
        rowOptions: [{ value: 10 }, { value: 25 }, { value: 50 }, { value: 100 }, { value: 200 }, { value: 500 }],
    },
};
